import styled from 'styled-components';
import { LoaderOverlayStyled } from '../LoaderOverlayStyled';

export const LoaderOverlayStyledDS = styled(LoaderOverlayStyled)``;
